<template>

<!--  <text style="text-align: center">线上班级学习记录 </text>-->
<!--  <text style="text-align: right">牛逼不</text>-->

  <div align="center">
    <div class="exam_detail" v-loading="loading">
      <template v-if="detailData">
        <template v-if="detailData.judge_choices.length > 0">
          <div class="title">一、判断题</div>
          <template v-for="(item, i) in detailData.judge_choices">
            <div class="content">
              <div class="content_title">{{i+1}}、{{item.problem}}</div>
              <el-radio-group class="content_answer" v-model="item.select_index">
                <template v-for="(sub_item, sub_i) in item.choice_info">
                  <el-radio :label="sub_i">{{sub_item.key}}、{{sub_item.value}}</el-radio>
                </template>
              </el-radio-group>
            </div>
          </template>
        </template>
        <template v-if="detailData.single_choices.length > 0">
          <div class="title">二、单选题</div>
          <template v-for="(item, i) in detailData.single_choices">
            <div class="content">
              <div class="content_title">{{i+1}}、{{item.problem}}</div>
              <el-radio-group class="content_answer" v-model="item.select_index">
                <template v-for="(sub_item, sub_i) in item.choice_info">
                  <el-radio :label="sub_i">{{sub_item.key}}、{{sub_item.value}}</el-radio>
                </template>
              </el-radio-group>
            </div>
          </template>
        </template>

        <template v-if="detailData.multiple_choices.length > 0">
          <div class="title">三、多选题</div>
          <template v-for="(item, i) in detailData.multiple_choices">
            <div class="content">
              <div class="content_title">{{i+1}}、{{item.problem}}</div>
            </div>
          </template>
        </template>
      </template>
    </div>
    <div v-if="detailData" style="margin-top: 20px;">
      <el-button type="primary" @click="onSubmit">提交答案</el-button>
    </div>
  </div>
</template>

<script>
  import {APIRequest} from '@/api/api';

  export default {
    data() {
      return {
        loading: true,
        tid: this.$route.query.tid,
        class_tid: this.$route.query.class_tid ? this.$route.query.class_tid : 0,
        detailData: null
      };
    },
    created() {
      this.fetchDetail();
    },
    methods: {
      fetchDetail() {
        let self = this;
        let params = {tid: self.tid};
        self.loading = true;
        APIRequest('getExamInfo', params, true).then(res => {
          self.loading = false;
          self.detailData = res.data;
          //console.log(self.detailData);
        }, err => {
          self.loading = false;
        });

        if (0 === undefined) {
          console.log('ddddd');
        } else {
          console.log('bbbb');
        }
      },
      onSubmit() {
        let can_submit = true;
        // 解析判断题
        for (let i=0; i<this.detailData.judge_choices.length; i++) {

          if (this.detailData.judge_choices[i].select_index === undefined) {
            can_submit = false;
          } else {

            for (let j=0; j<this.detailData.judge_choices[i].choice_info.length; j++) {
              if (j === this.detailData.judge_choices[i].select_index) {
                this.detailData.judge_choices[i].choice_info[j].is_select = true;
              } else {
                this.detailData.judge_choices[i].choice_info[j].is_select = false;
              }
            }
          }
        }
        // 解析单选题
        for (let i=0; i<this.detailData.single_choices.length; i++) {
          if (this.detailData.single_choices[i].select_index === undefined) {
            can_submit = false;
          } else {
            for (let j=0; j<this.detailData.single_choices[i].choice_info.length; j++) {
              if (j === this.detailData.single_choices[i].select_index) {
                this.detailData.single_choices[i].choice_info[j].is_select = true;
              } else {
                this.detailData.single_choices[i].choice_info[j].is_select = false;
              }
            }
          }
        }
        // 多选题
        for (let i=0; i<this.detailData.multiple_choices.length; i++) {
          if (this.detailData.multiple_choices[i].select_index === undefined) {
            can_submit = false;
          } else {
            for (let j=0; j<this.detailData.multiple_choices[i].choice_info.length; j++) {
              if (j === this.detailData.multiple_choices[i].select_index) {
                this.detailData.multiple_choices[i].choice_info[j].is_select = true;
              } else {
                this.detailData.multiple_choices[i].choice_info[j].is_select = false;
              }
            }
          }
        }
        if (can_submit === false) {
          this.$message.error('您还有题目未做完');
          return;
        }

        let params = {
          class_tid: this.class_tid,
          data: this.detailData
        };

        console.log(params);

        let self = this;
        APIRequest('inputExamInfo', params, true).then(res => {
          console.log(res);
          self.$router.replace({ path: '/my_exam' });
        }, err => {
          console.log(err);
        });
      }
    }
  }
</script>

<style>
  .exam_detail {
    position: relative;
    text-align: left;
    min-width: 1040px;
    max-width: 1300px;
    margin: 20px 200px 20px 200px;
    padding: 0;
  }

  .exam_detail .title {
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 20px;
    margin-left: 10px;
  }
  .exam_detail .content {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-left: 40px;
  }
  .exam_detail .content .content_title {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .exam_detail .content .content_answer {
    margin-left: 20px;
  }

  .el-radio {
    display: block;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/QuestionsPaper/Detail.vue